<template>
  <div>
    <vxe-card>
      <template #title>
        <vxe-select v-model="query['owner.id']" :options="owners" placeholder="placeholder.owner" @change="refresh"/>
        <vxe-input v-model="query['order.no']" placeholder="placeholder.purchaseOrderNo" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="query['supplier.name']" placeholder="placeholder.supplierName" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="query['item.no']" placeholder="placeholder.itemNo" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="query['item.name']" placeholder="placeholder.itemName" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="query['item.barcodes']" placeholder="placeholder.itemBarcode" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="query['lot.no']" placeholder="placeholder.lotNo" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-date-range-picker v-model="query.range" clearable linked-panels placeholder="business.label.invoiceTime" type="date" @change="refresh"/>
      </template>
      <template #extra>
        <vxe-button content="button.query" icon="vxe-icon-search" status="primary" @click="refresh"/>
        <vxe-button content="button.reset" icon="vxe-icon-undo" status="danger" @click="reset"/>
        <vxe-button content="button.expConfirm" icon="vxe-icon-upload" status="info" @click="exp"/>
      </template>
      <vxe-table ref="table" :data="data" :export-config="{}" :loading="loading">
        <vxe-column fixed="left" type="seq" width="40"/>
        <vxe-column field="purchaseOrder.invoiceTime" sortable title="business.label.invoiceTime" width="170"/>
        <vxe-column field="purchaseOrder.no" sortable title="business.label.orderNo" width="120"/>
        <vxe-column field="orderType.name" title="business.label.orderType" width="120"/>
        <vxe-column :cell-render="{name:'FormatSelect',options:orderStatus}" field="purchaseOrder.orderStatus" sortable title="business.label.orderStatus" width="100"/>
        <vxe-column field="owner.name" title="business.label.ownerName" width="120"/>
        <vxe-column field="supplier.name" title="business.label.supplierName" width="150"/>
        <vxe-column field="logicalStore.name" title="business.label.logicalStore" width="120"/>
        <vxe-column field="item.no" title="business.label.itemNo" width="80"/>
        <vxe-column field="item.name" title="business.label.itemName" width="120"/>
        <vxe-column field="pack.specification" title="business.label.specification" width="150"/>
        <vxe-column field="pack.factor" title="business.label.factor" width="50"/>
        <vxe-column field="pack.uom" title="business.label.uom" width="60"/>
        <vxe-column field="purchaseDetail.plannedQuantity" title="business.label.plannedQuantity" width="150"/>
        <vxe-column field="purchaseDetail.price" title="business.label.price" width="120"/>
      </vxe-table>
      <template #footer>
        <vxe-pager :current-page="page" :loading="loading" :page-size="size" :total="contentSize" @page-change="pageChange"/>
      </template>
    </vxe-card>
  </div>
</template>

<script>
import { findAll } from '@/api/Api'
import moment from 'moment'
import { getEnums, getOptions } from '@/utils/util'

export default {
  name: 'PurchaseDetailQuery',
  data() {
    return {
      loading: false,
      data: [],
      query: {
        'owner.id': undefined,
        'order.no': '',
        'supplier.name': '',
        'item.no': '',
        'item.name': '',
        'item.barcodes': '',
        'lot.no': '',
        range: [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')]
      },
      owners: [],
      orderStatus: [],
      page: 1,
      size: 20,
      contentSize: 0
    }
  },
  created() {
    findAll('partyFactory', { available: true, 'type.ordinal': 1 }).then(res => {
      if (res.success) {
        this.owners = getOptions(res.result)
      }
      return getEnums('OrderStatus')
    }).then(result => {
      this.orderStatus = result
    })
  },
  methods: {
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.fetch()
    },
    fetch() {
      this.loading = true
      const args = Object.assign({}, this.query)
      if (args.range.length > 0) {
        args['invoiceTimeFilter'] = { start: args.range[0], end: args.range[1] }
      } else {
        args['invoiceTimeFilter'] = null
      }
      findAll('purchaseDetailFactory', args, this.page, this.size).then(res => {
        if (res.success) {
          this.data = res.result
          this.contentSize = res.contentSize
        }
      }).finally(() => this.loading = false)
    },
    refresh() {
      this.page = 1
      this.fetch()
    },
    reset() {
      this.query = {
        'owner.id': undefined,
        'order.no': '',
        'supplier.name': '',
        'item.no': '',
        'item.name': '',
        'item.barcodes': '',
        'lot.no': '',
        range: [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')]
      }
      this.refresh()
    },
    exp() {
      this.$refs.table.openExport()
    }
  }
}
</script>